export default __webpack_public_path__ + "static/mergeVideo-4acb7431220996c2d5ffe69d115a7b89.webm";